export default __webpack_public_path__ + "static/media/peg.a759e0fa.gif";